'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _decisivUiUtils = require('decisiv-ui-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  flexRow: function flexRow() {
    return {
      styles: 'flex-direction: row;'
    };
  }
};

var Data = function Data(props) {
  var componentProps = (0, _lodash.omit)(props, ['modifiers']);
  return _react2.default.createElement(_styledComponentsReactiveGrid.Column, _extends({}, componentProps, { modifiers: ['col'] }));
};

// this acts as our <td> element
var styles = function styles(_ref) {
  var flex = _ref.flex,
      minWidth = _ref.minWidth;
  return '\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  flex: ' + flex + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  justify-content: flex-start;\n  min-height: ' + (0, _decisivUiUtils.px2rem)(60) + ';\n  min-width: ' + (0, _decisivUiUtils.px2rem)(minWidth) + ';\n';
};

var defaultProps = {
  flex: 1,
  minWidth: 100
};

var propTypes = {
  flex: _propTypes2.default.number.isRequired,
  minWidth: _propTypes2.default.number.isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Data', (0, _styledComponents2.default)(Data), styles, {
  defaultProps: defaultProps,
  modifierConfig: modifierConfig,
  propTypes: propTypes
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/ListTable/Data.js
// module id = 1596
// module chunks = 2